import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { RacingCombinedView } from "./RacingCombinedView";
import { RacingCombinedViewData } from "./data";
let _;
let _localMocks;
let PageMethodsMock;
let RacingPageMethodsMock;
let ApplicationNavigationMock;
let OverridenPageMethodsResponses;
let GetUniqueClassMock;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-legacy-integration/lib-esm/mocks");
    _localMocks = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    RacingPageMethodsMock = _localMocks.RacingPageMethodsMock;
    ApplicationNavigationMock = _.NavHandlerMock;
    OverridenPageMethodsResponses = _localMocks.PageMethodsOverridenMockedMethods;
    GetUniqueClassMock = _.getUniqueOddsClass;
}
export class RacingCombinedViewRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {}
    }) {
        super(domId, options);
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
        if (process.env.NODE_ENV === "development") {
            this.racingGameBlockNav = () => { };
            // setup data mocks for debug build
            this.dataProvider = new RacingCombinedViewData({
                pageMethods: new PageMethodsMock(new OverridenPageMethodsResponses()),
                racingPageMethods: new RacingPageMethodsMock(),
                getUniqueOddsClass: GetUniqueClassMock
            }, options.cms.nextRacesCount, new ApplicationNavigationMock());
            // setup dictionary for debug build
            this.options.dict = BaseDict;
            //export data store to window for debug purposes
            window["RacingCombinedViewDATA"] = this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new RacingCombinedViewData(options.dataProvider, options.cms.nextRacesCount, options.navHandler.Navigation);
            this.racingGameBlockNav = OpenRacingGame;
        }
    }
    activate() {
        return super.activate(React.createElement(RacingCombinedView, { dataProvider: this.dataProvider, dict: this.options.dict, options: this.options, racingGameBlockNav: this.racingGameBlockNav }));
    }
}
window["RacingCombinedView"] = RacingCombinedViewRoot;
broadcastBlockLoad("RacingCombinedView");
//# sourceMappingURL=index.js.map